"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { System } from "Constants/objects";
import Box, { Item } from 'devextreme-react/box';

var styles = function styles(theme) {
  return {
    d5FormCaption: {
      fontSize: 20,
      borderBottom: '1px solid #d5d9da',
      paddingBottom: 3,
      margin: '0 2px',
      flex: '0 0 auto'
    },
    firstItem: {
      paddingRight: theme.spacing.unit
    },
    lastItem: {
      paddingLeft: theme.spacing.unit
    },
    item: {
      padding: "0 ".concat(theme.spacing.unit, "px")
    }
  };
};

var D5FormLayoutPanelClass =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(D5FormLayoutPanelClass, _PureComponent);

  function D5FormLayoutPanelClass() {
    _classCallCheck(this, D5FormLayoutPanelClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(D5FormLayoutPanelClass).apply(this, arguments));
  }

  _createClass(D5FormLayoutPanelClass, [{
    key: "getCaption",
    value: function getCaption(caption) {
      return React.createElement(Item, {
        ratio: 0,
        baseSize: 'auto',
        key: 1
      }, React.createElement("div", {
        className: 'dx-form-group-with-caption',
        style: {
          paddingBottom: 8
        }
      }, React.createElement("span", {
        className: 'dx-form-group-caption'
      }, caption), React.createElement("div", {
        className: 'dx-form-group-content',
        style: {
          paddingBottom: 0,
          paddingTop: 0
        }
      })));
    }
  }, {
    key: "groupContent",
    value: function groupContent() {
      var caption = this.props.caption;
      var result = [];

      if (caption) {
        result.push(this.getCaption(caption));
      }

      result.push(this.getContent());
      return result;
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var orientation = this.props.orientation;
      return React.createElement(Item, {
        ratio: 1,
        key: 2,
        baseSize: 'auto'
      }, React.createElement(Box, {
        width: "100%",
        height: "100%",
        direction: orientation
      }, this.groupItems()));
    }
  }, {
    key: "itemPropsByType",
    value: function itemPropsByType(_ref) {
      var isGroup = _ref.isGroup,
          groupType = _ref.groupType,
          itemType = _ref.itemType,
          items = _ref.items,
          isVisible = _ref.isVisible;
      var _System$LAYOUT_TYPE = System.LAYOUT_TYPE,
          FILTER = _System$LAYOUT_TYPE.FILTER,
          DECORATION = _System$LAYOUT_TYPE.DECORATION;
      var TAB_PANEL = System.GROUP_TYPE.TAB_PANEL;
      var STR = System.ORIENTATION.STR;
      var orientation = this.props.orientation;

      if (isGroup) {
        if (this.hasTableChild(items) || groupType === TAB_PANEL) return {
          ratio: 1,
          shrink: 0,
          baseSize: 0
        };
        return {
          ratio: 0,
          shrink: 0,
          baseSize: 'auto'
        };
      }

      switch (itemType) {
        case FILTER:
          if (!isVisible) {
            return {
              ratio: 0,
              shrink: 0,
              baseSize: 'auto'
            };
          }

          return {
            ratio: 1,
            shrink: 1,
            baseSize: 1
          };

        case DECORATION:
          if (STR.ROW === orientation) {
            return {
              ratio: 0,
              shrink: 0,
              baseSize: 'auto'
            };
          }

          return {
            ratio: 0,
            shrink: 1,
            baseSize: 'auto'
          };

        default:
          return {
            ratio: 1,
            shrink: 0,
            baseSize: 0
          };
      }
    }
  }, {
    key: "hasTableChild",
    value: function hasTableChild(items) {
      var SUBFORM = System.LAYOUT_TYPE.SUBFORM;

      if (!Array.isArray(items) || !items.length) {
        return false;
      }

      return items.some(function (item) {
        return item.itemType === SUBFORM;
      });
    }
  }, {
    key: "groupItems",
    value: function groupItems() {
      var _this = this;

      var _this$props = this.props,
          _this$props$children = _this$props.children,
          children = _this$props$children === void 0 ? [] : _this$props$children,
          classes = _this$props.classes;
      var _System$LAYOUT_TYPE2 = System.LAYOUT_TYPE,
          FILTER = _System$LAYOUT_TYPE2.FILTER,
          SUBFORM = _System$LAYOUT_TYPE2.SUBFORM,
          DECORATION = _System$LAYOUT_TYPE2.DECORATION;
      return React.Children.map(children, function (child, i) {
        var _this$itemPropsByType = _this.itemPropsByType(child.props),
            baseSize = _this$itemPropsByType.baseSize,
            ratio = _this$itemPropsByType.ratio,
            shrink = _this$itemPropsByType.shrink;

        var className = '';

        if ([FILTER, DECORATION].includes(child.props.itemType) && child.props.isVisible) {
          className = classes.item;

          if (i === 0 && children.length > 1) {
            className = classes.firstItem;
          }

          if (i === children.length - 1 && children.length > 11) {
            className = classes.lastItem;
          }
        }

        return React.createElement(Item, {
          ratio: ratio,
          baseSize: baseSize,
          shrink: shrink,
          key: i
        }, React.createElement("div", {
          style: {
            width: '100%',
            height: '100%'
          },
          className: className
        }, child));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Box, {
        direction: "col",
        width: "100%",
        height: "100%",
        style: {
          padding: 3
        }
      }, this.groupContent());
    }
  }]);

  return D5FormLayoutPanelClass;
}(PureComponent);

_defineProperty(D5FormLayoutPanelClass, "propTypes", {
  classes: PropTypes.object.isRequired,
  caption: PropTypes.string,
  orientation: PropTypes.string.isRequired,
  items: PropTypes.array
});

export default withStyles(styles)(D5FormLayoutPanelClass);